<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  created() {
    var name = 't';
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    let webUrl = "";
    if (r) {
      let t = unescape(r[2]);
      webUrl = "t=" + t + "&ts=" + new Date().getTime();
      localStorage.setItem('t', JSON.stringify(t));
    } else {
      webUrl = "t=y_gw3" + "&ts=" + new Date().getTime();
      localStorage.setItem('t', JSON.stringify('y_gw3'));
    }
    // axios
    //   .get("/web/idfa/set?" + webUrl)
    //   .then(data => {
    //     console.log("请求成功");
    //   })
    //   .catch(err => {
    //     console.log("请求失败");
    //   });

    let u = navigator.userAgent;
    let android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let iOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    let p = ''
    if(iOS) {
      p = 2;
    } else if(android) {
      p = 1;
    } else {
      p = 3;
    }
    let apiUrl = '';
    if (r) {
      let t = unescape(r[2]);
      apiUrl = "flag=" + t + '&p=' + p + "&ts=" + new Date().getTime();
    } else {
      apiUrl = "flag=y_gw3" + '&p=' + p + "&ts=" + new Date().getTime();
    }
    axios
      .post("/api/v1/idfa/set?" + apiUrl)
      .then(data => {
        console.log("请求成功");
      })
      .catch(err => {
        console.log("请求失败");
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue